import { Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import './style.less';

/**
 * Тайлангийн шүүлтүүрийн нэг талбар — гарчиг + контрол (RangePicker, Select гэх мэт).
 */
export const ReportField = ({ label, children }) => (
  <div className="report_filter__field">
    <span className="report_filter__label">{label}</span>
    {children}
  </div>
);

/**
 * Бүх тайлангийн (захиалга, бараа, үлдэгдэл) дээд талын шүүлтүүрийн мөр.
 * Хүснэгттэйгээ нэг `pp_table_wrapper` карт дотор байрлана.
 *
 *   <ReportFilterBar onSearch={...} loading={...} actions={<ExportButton />}>
 *     <ReportField label="Хугацаа">...</ReportField>
 *   </ReportFilterBar>
 */
const ReportFilterBar = ({ children, onSearch, loading, actions }) => (
  <div className="report_filter">
    {children}

    <Button
      type="primary"
      className="all_buttons"
      icon={<SearchOutlined />}
      onClick={onSearch}
      loading={loading}
    >
      Хайх
    </Button>

    {actions ? <div className="report_filter__actions">{actions}</div> : null}
  </div>
);

export default ReportFilterBar;
